export default "__VITE_ASSET__c0779035__"